<rw-modal
  modalId="createRenameFolderModal"
  datapendoid="create-rename-folder-modal"
  datatestid="create-rename-folder-modal"
  [title]="configuration?.dialogTitle"
  [arialabel]="configuration?.dialogTitle"
  [dismissible]="false"
  size="lg"
  #modalRef
> 
 <div modal-body>
    <form #containerForm="ngForm" name="containerForm" novalidate>
      <fieldset>
        <div
          class="form-group"
          [ngClass]="{
            'has-error': hasAnyError || hasNameInUseError,
          }"
        >
          <div class="p-field">
            <label for="folderName" class="folder_name">Folder Name</label>
            <input
              #folderNameFocus
              id="folderName"
              #folderNameField="ngModel"
              data-testid="folderName"
              type="text"
              autocomplete="off"
              maxlength="64"
              minlength="1"
              name="folderName"
              class="form-control"
              [(ngModel)]="pendingFolderName"
              (input)="onInputChange($event.target.value)"
              required
              placeholder="Folder Name"
              class="form-control ui-inputtext"
            />
            <div>
              @if (
                folderNameField?.errors?.required &&
                !folderNameField?.errors?.pendingvalidation
              ) {
                <div data-testid="nameReqiredMsg" class="help-block">Required field</div>
              }
              @if (folderNameField?.errors?.maxlength && !folderNameField?.errors?.pendingvalidation) {
                <div data-testid="nameLengthErr" class="help-block">
                  Folder name is too long (must be less than 64 characters)
                </div>
              }
              @if (
                hasPatternError
              )           {
                <div data-testid="specialCharErr" class="help-block">
                  Folder name cannot contain the following special characters: tab, < > " : / \ | ? * , &
                </div>
              }
              @if (hasNameInUseError) {
                <div data-testid="nameExistsErr" class="help-block">
                  Folder with this name already exists at this level
                </div>
              }
              @if (working) {
                <div class="help-block">
                  <span data-testid="checkingNameMsg">Checking if folder name is unique... </span
                  ><app-icon
                    data-testid="whiteLoadingSpinner"
                    source="rn-circle-notch"
                    imgClass="loading-spinner white-icon "
                  ></app-icon>
                </div>
              }
                          </div>
            </div>
          </div>
      </fieldset>
    </form>
    @if (configuration.isEdit) {
      <div>
        <strong>Note:</strong> Updating the folder <strong>{{ configuration.currentName }}</strong> will lock
        organizations that have users with access to this folder until the renaming process has completed.
      </div>
    }
  </div>
  <div modal-footer>
    <app-button
      id="btnCancel"
      label="CANCEL"
      noContentPadding="true"
      buttonStyle="addUserTeritary"
      [processing]="working"
      [showProcessing]="true"
      [disabled]="working"
      (clickActionEmitter)="close()"
    >
    </app-button>
    <app-button
      id="btnSubmit"
      noContentPadding="true"
      buttonStyle="primary"
      [label]="configuration?.buttonText"
      [disabled]="submitDisabled"
      [showProcessing]="true"
      [processing]="working"
      (clickActionEmitter)="submit()"
    >
    </app-button>
  </div>
</rw-modal>
    